import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "./Header";
import Footer from "./Footer";
import FloatingCallButton from "./FloatingCallButton";

interface LayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
}

const NiceJobEngage = () => {
  useEffect(() => {
    if (document.querySelector('script[src*="nicejob.co"]')) return;
    let loaded = false;
    const load = () => {
      if (loaded) return;
      loaded = true;
      cleanup();
      const script = document.createElement("script");
      script.src = "https://cdn.nicejob.co/js/sdk.min.js?id=16fbfff1-4a27-4ba8-ae61-4981e7d3cec4";
      script.defer = true;
      document.body.appendChild(script);
    };
    const events: (keyof WindowEventMap)[] = ["scroll", "pointerdown", "keydown", "touchstart"];
    const cleanup = () => events.forEach((e) => window.removeEventListener(e, load));
    events.forEach((e) => window.addEventListener(e, load, { once: true, passive: true } as AddEventListenerOptions));
    const t = window.setTimeout(load, 6000);
    return () => { cleanup(); window.clearTimeout(t); };
  }, []);

  return <div className="nj-engage" data-position="left" />;
};

const Layout = ({ children, title, description }: LayoutProps) => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const baseTitle = "Ivana Glow Medical Spa";
  const fullTitle = title ? `${title} | ${baseTitle}` : baseTitle;
  const metaDescription = description || "Ivana Glow Medical Spa in Lake Forest, IL. 25+ years experience in medical aesthetics, facials, chemical peels, and skin rejuvenation. Call (847) 283-0204 to book.";

  return (
    <>
      <Helmet>
        <title>{fullTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={fullTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={fullTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta property="og:url" content={`https://www.ivanaglowmedicalspa.com${location.pathname}`} />
        <link rel="canonical" href={`https://www.ivanaglowmedicalspa.com${location.pathname}`} />
      </Helmet>
      
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <FloatingCallButton />
        <NiceJobEngage />
      </div>
    </>
  );
};

export default Layout;
